import ReactOnRails from 'react-on-rails';

import { LpStepSchoolInfoForm } from 'bundles/lp/members/step';

ReactOnRails.register({
  LpStepSchoolInfoForm: LpStepSchoolInfoForm
});
